export default function(state = null, action) {
  switch(action.type) {
  case 'REPOSITORY_SELECTED':
    return action.payload;
  default:
    return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/reducer_selected_repository.js